<template>
    <div class="foodWarehouseadd ">
        <div class="top">
            
          <el-button @click="$router.go(-1)" type="default" size="medium">返回</el-button>
          <el-button type="primary" size="medium" @click="updateMaterials('ruleForm')">保存</el-button>
        </div>
        <div class="subject" :style="`height: ${windowHeight-180}px;`">
            <div class="body">
             <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="160px" class="demo-ruleForm">
                <el-form-item label="名称" prop="name">
                    <el-input v-model="ruleForm.name" size="medium" :maxlength="20"  placeholder="请输入名称"></el-input>
                </el-form-item>
                <el-form-item label="类型" prop="typeId">
                    <el-select v-model="ruleForm.typeId" placeholder="请选择类型" size="medium">
                    <el-option  :value="item.id"  :label="item.value" v-for="item in foodTypeList" :key="item.id"></el-option>
                    </el-select>                    
                </el-form-item>
                 <el-form-item label="图片" class="pic">
                    <uploader  :multiple="false" v-model="piclist" :extList="['jpeg', 'jpg', 'bmp', 'gif', 'png']" showMode="cover" :showModeCover="true" showResult="image"></uploader>
                    <div class="img-b-box">点击更换图片</div>                    
                </el-form-item>
                <el-form-item label="食部(%)" prop="foodPart">
                    <el-input-number size="medium" placeholder="请输入食部"  :precision="0" :step="0.01" :min="1" :max="100" v-model="ruleForm.foodPart"></el-input-number>
                </el-form-item>
                <el-form-item label="能量(卡路里)" prop="energy">
                    <el-input-number size="medium" :precision="2" placeholder="请输入能量(卡路里)" :step="0.01" :min="0.01" :max="10000" v-model="ruleForm.energy"></el-input-number>
                </el-form-item>
                <el-form-item label="蛋白质(g)" prop="protein">
                    <el-input-number size="medium" :precision="2" placeholder="请输入蛋白质(g)" :step="0.01" :min="0.01" :max="10000" v-model="ruleForm.protein"></el-input-number>
                </el-form-item>
                <el-form-item label="脂肪(g)" prop="fat">
                    <el-input-number size="medium" :precision="2" placeholder="请输入脂肪(g)" :step="0.01" :min="0.01" :max="10000" v-model="ruleForm.fat"></el-input-number>
                </el-form-item>
                <el-form-item label="碳水化合物(g)" prop="carbohydrate">
                    <el-input-number size="medium" :precision="2" placeholder="请输入碳水化合物(g)" :step="0.01" :min="0.01" :max="10000" v-model="ruleForm.carbohydrate"></el-input-number>
                </el-form-item>
                <el-form-item label="维生素A (mg)" prop="vitaminA">
                    <el-input-number v-model="ruleForm.vitaminA"  size="medium" :precision="3" placeholder="请输入维生素A (mg)" :step="0.001" :min="0.001" :max="10000" ></el-input-number>
                </el-form-item>
                <el-form-item label="硫胺素(mg)维生素B1" prop="vitaminB1">
                    <el-input-number v-model="ruleForm.vitaminB1"  size="medium" :precision="3" placeholder="请输入硫胺素(mg)维生素B1" :step="0.001" :min="0.001" :max="10000" ></el-input-number>
                </el-form-item>
                <el-form-item label="核黄素(mg)维生素B2" prop="vitaminB2">
                    <el-input-number v-model="ruleForm.vitaminB2"  size="medium" :precision="3" placeholder="请输入核黄素(mg)维生素B2" :step="0.001" :min="0.001" :max="10000" ></el-input-number>
                </el-form-item>
                <el-form-item label="维生素C(mg)" prop="vitaminC">
                    <el-input-number v-model="ruleForm.vitaminC"  size="medium" :precision="3" placeholder="请输入维生素C(mg)" :step="0.001" :min="0.001" :max="10000" ></el-input-number>
                </el-form-item>
                <el-form-item label="维生素E(mg)" prop="vitaminE">
                    <el-input-number v-model="ruleForm.vitaminE"  size="medium" :precision="3" placeholder="请输入维生素E(mg)" :step="0.001" :min="0.001" :max="10000" ></el-input-number>
                </el-form-item>
                <el-form-item label="钙(mg)" prop="ca">
                    <el-input-number v-model="ruleForm.ca"  size="medium" :precision="3" placeholder="请输入钙(mg)" :step="0.001" :min="0.001" :max="10000" ></el-input-number>
                </el-form-item>
                <el-form-item label="铁(mg)" prop="fe">
                    <el-input-number v-model="ruleForm.fe"  size="medium" :precision="3" placeholder="请输入铁(mg)" :step="0.001" :min="0.001" :max="10000" ></el-input-number>
                </el-form-item>
                <el-form-item label="锌(mg)" prop="zn">
                    <el-input-number v-model="ruleForm.zn"  size="medium" :precision="3" placeholder="请输入锌(mg)" :step="0.001" :min="0.001" :max="10000" ></el-input-number>
                </el-form-item>              
                </el-form>
            </div>
         </div>   
    </div>
</template>
<script>
import { findDicsByCode,updateMaterial,materialDetails} from "@/api/foodSetting";
import mixin from "@/mixins/windowResize";
import Uploader from "@/components/Uploader/WebUploader";
export default {
  components: { Uploader },
  data() {
    return {
      id:this.$route.query.id,
      ruleForm: {
        ca:undefined,//	钙	string	
        carbohydrate:undefined,//	碳水化合物	string	
        energy:undefined,//	能量	string	
        fat:undefined,//	脂肪	string	
        fe:undefined,//	铁	string	
        foodPart:undefined,//	食部	number	
        name:'',//	食材名称	string	
        pic:'',//	图片，可空	string	
        protein:undefined,//	蛋白质	string	
        typeId:'',//	类型Id	number	
        typeName:'',//	类型名称	string	
        vitaminA:undefined,//	维生素A	string	
        vitaminB1:undefined,//	维生素B1	string	
        vitaminB2:undefined,//	维生素B2	string	
        vitaminC:undefined,//	维生素C	string	
        vitaminE:undefined,//	维生素E	string	
        zn:undefined,//	锌	string	
      },
      rules: {
        name: [
          { required: true, message: "请输入名称", trigger: "blur" }
        ],
        typeId: [
          { required: true, message: "请选择类型", trigger: "change" }
        ],
        foodPart:[
          { required: true, message: "请输入食部", trigger: "change" },
          { required: true, message: "请输入食部", trigger: "blur" }
        ],
        energy:[
          { required: true, message: "请输入能量(卡路里)", trigger: "change" },
          { required: true, message: "请输入能量(卡路里)", trigger: "blur" }
        ],
        carbohydrate:[
          { required: true, message: "请输入碳水化合物(g)", trigger: "change" },
          { required: true, message: "请输入碳水化合物(g)", trigger: "blur" }
        ],
        fat:[
          { required: true, message: "请输入脂肪(g)", trigger: "change" },
          { required: true, message: "请输入脂肪(g)", trigger: "blur" }
        ],
        protein:[
          { required: true, message: "请输入蛋白质(g)", trigger: "change" },
          { required: true, message: "请输入蛋白质(g)", trigger: "blur" }
        ],
        vitaminA:[
          { required: true, message: "请输入维生素A (mg)", trigger: "change" },
          { required: true, message: "请输入维生素A (mg)", trigger: "blur" }
        ],
        vitaminB1:[
          { required: true, message: "请输入硫胺素(mg)维生素B1", trigger: "change" },
          { required: true, message: "请输入硫胺素(mg)维生素B1", trigger: "blur" }
        ],
        vitaminB2:[
          { required: true, message: "请输入核黄素(mg)维生素B2", trigger: "change" },
          { required: true, message: "请输入核黄素(mg)维生素B2", trigger: "blur" }
        ],
        vitaminC:[
          { required: true, message: "请输入维生素C(mg)", trigger: "change" },
          { required: true, message: "请输入维生素C(mg)", trigger: "blur" }
        ],
        ca:[
          { required: true, message: "请输入钙(mg)", trigger: "change" },
          { required: true, message: "请输入钙(mg)", trigger: "blur" }
        ],
        fe:[
          { required: true, message: "请输入铁(mg)", trigger: "change" },
          { required: true, message: "请输入铁(mg)", trigger: "blur" }
        ],
        zn:[
          { required: true, message: "请输入锌(mg)", trigger: "change" },
          { required: true, message: "请输入锌(mg)", trigger: "blur" }
        ],
      },
      foodTypeList: [],
      piclist: [
          {
          fileUrl:
            "https://cdnfile-10043692.file.myqcloud.com/admin/images/shanshi/shiwu.png",
          fileName: "shiwu.png"
        }
      ],
    };
  },
  created() {
    findDicsByCode("material")
      .then(res => {
        if (res.data.data.length > 0 && res.data.data) {
          this.foodTypeList = res.data.data;
        }
      })
      .catch();
      this.materialDetailss();
  },
  mixins: [mixin],
  methods: {
       materialDetailss(){
       materialDetails(this.id).then(res => res.data).then(data => {
          if(data.code==200){
            let mydata=data.data;
            this.ruleForm=mydata;
            console.log(this.ruleForm)
            this.piclist=[{
                 fileUrl:mydata.pic,
                 fileName: "shiwu.png"
            }]
          }     
       })
     },
   
    //保存
    updateMaterials(formName){
        this.$refs[formName].validate((valid) => {
          if (valid) {            
            this.ruleForm.pic=this.piclist[0].fileUrl;
            for(let i=0;i<this.foodTypeList.length;i++){
                if(this.foodTypeList[i].id==this.ruleForm.typeId){
                    this.ruleForm.typeName=this.foodTypeList[i].value;
                }
            };
            let $this=this;
             updateMaterial(this.ruleForm)
              .then(res => {
                if (res.data.code === 200) {
                  $this.$message({
                    type: "success",
                    message: "操作成功!"
                  });
                  $this.$router.go(-1);
                }else{
                  this.$message({type: 'error', message:res.data.msg});
                  return;
                }             
              }).catch();
          };
        });
    },
  }
};
</script>
<style>
.foodWarehouseadd .upload-file-item img {
  width: 80px !important;
  height: 80px !important;
  margin: 0;
  border: 1px dashed #409EFF;
  box-sizing: border-box;
  margin: 0 !important;
}
.foodWarehouseadd .upload-block-container .upload-file-item {
  height: 80px;
}
.foodWarehouseadd .upload-file-item .file-name {
  display: none;
}
</style>
<style lang="scss" scoped>
.foodWarehouseadd {
  padding: 12px;
  * {
    box-sizing: border-box;
  }  
  .top {
    border-bottom: 1px solid #e7eaec;
    padding-bottom: 10px;
  }
  .subject {
    padding-top: 10px;
    overflow: auto;
    .body {
      width: 810px;
      margin: 0 auto;      
      .el-select {
        width: 100%;
      }    
      .el-input-number--medium {
            width: 280px;
        } 
      .img-b-box {
        position: absolute;
        bottom: 1px;
        left: 0px;
        width: 80px;
        text-align: center;
        color: #fff;
        height: 24px;
        line-height: 24px;
        background: rgba(0, 0, 0, 0.5);
      }  
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/foodSetting/foodWarehouseeidt.vue